<template>
  <div class="mainContent grid">
    <div class="page-block u-16 fixedfilter">
      <div class="title-page">
        <h1>Сплиты</h1>
        <span>(всего: {{ totalOrders | totalOrdersFilter }})</span>
      </div>
      <VisualSearch
        v-if="flag_cp"
        v-on:loadAsyncData="loadAsyncData"
        v-on:saveSearchParams="saveSearchParams"
        :merchantList="merchantList"
        :terminalList="terminalList"
        :processingList="processingList"
        :isReport="isReport"
        :isSplits="isSplits"
      />
    </div>

    <div class="main-table u-16" v-if="flag_cp">
      <section class="header-table">
        <div class="grid cross-center between table-title">
          <div>
            <b-field>
              <b-switch
                size="is-small"
                v-model="OnebyOne"
                class="onebyone"
                type="is-info"
                >Открывать по-одному</b-switch
              >
            </b-field>
          </div>
          <div>
            <el-button
              icon="el-icon-refresh"
              type="primary"
              plain
              @click="loadAsyncData()"
              :loading="loading"
              >Обновить</el-button
            >
          </div>
        </div>
      </section>
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <b-table
          :data="data"
          :loading="loading"
          :has-detailed-visible="() => true"
          backend-pagination
          :current-page="currentPage"
          pagination-size="is-small"
          :per-page="defParam.limit"
          :pagination-simple="isPaginationSimple"
          @page-change="PageChange"
          detailed
          narrowed
          :opened-detailed="openedDetailed"
          detail-key="id"
          hoverable
          mobile-cards
          :default-sort="[sortField, sortOrder]"
          :default-sort-direction="defaultSortOrder"
          ref="tableOrders"
          :row-class="rowClassDetails"
          @click="showTransactionInfo"
          class="splits-table"
        >
          <template slot-scope="props">
            <b-table-column
              field="merchant_order_id"
              label="№ заказа продавца"
              width="140"
              >{{ props.row.merchant_order_id }}
            </b-table-column>
            <b-table-column
              field="date_updated"
              label="Дата"
              width="140"
              sortable
              >{{ props.row.date_updated | momentFormat() }}
            </b-table-column>
            <b-table-column field="terminal_id" label="Терминал" width="180">{{
              terminalName(props.row.terminal_id)
            }}</b-table-column>
            <b-table-column
              field="terminal_id"
              label="Терминал контрагента"
              width="200"
              >{{ terminalName(props.row.split_terminal_id) }}
            </b-table-column>
            <b-table-column
              field="amount"
              width="100"
              label="Сумма"
              sortable
              numeric
              >{{ props.row.amount | amountFormat }}
              {{ currencyCharacter(props.row.currency_code) }}
            </b-table-column>
            <b-table-column
              field="state_id"
              label="Статус"
              class="status"
              width="110"
            >
              <span class="status-tag" :class="statusStyle(props.row.state_id)"
                >{{ statusName(props.row.state_id) }}
              </span>
            </b-table-column>
            <b-table-column
              field="processing_id"
              label="Процессинг"
              width="200"
            >
              <img
                class="processing-icon"
                :src="processingIcon(props.row.processing_id)"
              />
              {{ processingName(props.row.processing_id) }}
            </b-table-column>
            <b-table-column
              field="purpose"
              label="Назначение платежа"
              class="td-purpose"
              >{{ props.row.purpose }}
            </b-table-column>
          </template>

          <template slot="detail" slot-scope="props">
            <div class="content u-16 grid">
              <OrderInfo
                :rowId="props.row.transaction_id"
                :title="`Информация по родительскому заказу`"
                :showCP="false"
                :transactionInfo="getTransaction(props.row.transaction_id)"
                :merchantName="merchantName(props.row.merchant_id)"
                :terminalName="terminalName(props.row.terminal_id)"
                :fullWidth="false"
                style="margin-top:20px"
              ></OrderInfo>
              <OrderInfo
                :rowId="props.row.transaction_id"
                :title="`Информация о сплите`"
                :showCP="false"
                :transactionInfo="getSplitInfo(props.row)"
                :merchantName="merchantName(props.row.merchant_id)"
                :terminalName="terminalName(props.row.split_terminal_id)"
                :fullWidth="false"
                style="margin-top:20px"
              ></OrderInfo>
              <div
                class="u-16 hor-padding-20-ss hor-padding-5 grid between multicross-start splitinfo"
              >
                <OrderSplit
                  :orderSplit="getSplit(props.row.transaction_id)"
                  :currencyCode="props.row.currency_code"
                ></OrderSplit>
              </div>
            </div>
          </template>

          <template slot="empty">
            <section class="empty-table">
              <div class="content has-text-centered"><p>Нет данных</p></div>
            </section>
          </template>
        </b-table>
      </VuePerfectScrollbar>

      <div
        v-show="totalOrders / defParam.limit > 1"
        class="pagination-block grid center"
      >
        <el-pagination
          :current-page.sync="currentPage"
          background
          :pager-count="5"
          @current-change="PageChange"
          :page-size="defParam.limit"
          layout="prev, pager, next, jumper"
          :total="totalOrders"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";

import { mapGetters } from "vuex";

import "buefy/dist/buefy.css";

import VisualSearch from "@/components/VisualSearch";
import OrderInfo from "@/components/OrderInfo";
import AntifraudRules from "@/components/AntifraudRules";
import OrderSplit from "@/components/OrderSplit";

import moment from "moment";

import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
Vue.use(VueAxios, axios);

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "Splits",
  props: ["row"],
  data() {
    return {
      isReport: false,
      isSplits: true,
      data: [],
      total: 0,
      sortField: "Date",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      openedDetailed: [],
      OnebyOne: true,
      totalOrders: 0,
      currentPage: 1,
      isPaginationSimple: false,
      loading: false,
      loadingDialog: false,
      searchOptions: [
        "processings",
        "merchants",
        "terminals",
        "split_terminals",
        "merchant_orders",
        "map_orders",
        "amount_range",
        "date_range"
      ],
      defParam: {
        limit: 50,
        offset: 0,
        order_by: "id",
        order: "desc",
        transaction_id: -1
      },
      searchParams: {},
      customP: [],
      flag_cp: false,
      transactionInfo: [],
      dialogRefund: false,
      dialogChangeStatus: false,
      showColumn: false,
      scrollsettings: {
        suppressScrollY: false
      }
    };
  },
  methods: {
    saveSearchParams(params) {
      if (params != undefined) this.searchParams = params;
    },
    loadAsyncData(params) {
      let paramRequest = {};
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      if (!_.isEmpty(params) && params) {
        this.defParam.offset = 0;
        paramRequest = Object.assign({}, this.defParam, params);
      } else {
        paramRequest = Object.assign({}, this.defParam, this.searchParams);
      }
      this.loading = true;
      axios
        .post(apiUrl + "split", paramRequest, config)
        .then(({ data }) => {
          this.data = [];
          var currentTotal = data.total;
          this.totalOrders = currentTotal;
          if (this.totalOrders != 0) {
            data.list.forEach(item => {
              item.is_opened = false;
              this.data.push(item);
            });
          }
          this.loading = false;
        })
        .catch(error => {
          this.data = [];
          this.loading = false;
          throw error;
        });
    },
    PageChange: function(page) {
      this.currentPage = page;
      this.defParam.offset = (this.currentPage - 1) * this.defParam.limit;
      this.loadAsyncData();
    },
    showTransactionInfo(row) {
      if (this.OnebyOne == true) {
        // check open details one by one
        if (row.is_opened == true) {
          this.closeRow(row);
        } else {
          var oldOpened = this.openedDetailed;
          this.data.forEach(item => {
            if (item.id == oldOpened) {
              item.is_opened = false;
              this.closeRow(item);
            }
          });
          this.openedDetailed = [row.id];
          row.is_opened = true;
        }
      } else {
        if (row.is_opened == false) {
          this.openedDetailed.push(row.id);
          row.is_opened = true;
        } else {
          this.closeRow(row);
          row.is_opened = false;
        }
      }
    },
    closeRow(row) {
      var index = this.openedDetailed.indexOf(row.id);
      if (index >= 0) {
        this.openedDetailed.splice(index, 1);
      }
      row.is_opened = false;
    },
    rowClassDetails(row, index) {
      if (this.openedDetailed.indexOf(row.id) != -1) {
        row.is_opened = true;
        return "row-paid";
      } else return "";
    },
    getTransaction(id) {
      let params = {
        id: id
      };
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let resp = {};
      this.loadingDialog = true;
      var transactionInfo = { info: [] };
      axios
        .post(apiUrl + "transaction", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total == 1) {
            resp = data.list[0];
          }
        })
        .then(() => {
          this.cardId = resp.card_type_id;
          var order = _.pick(
            resp,
            "date_created",
            "date_updated",
            "amount",
            "currency_code",
            "terminal_id",
            "merchant_id",
            "merchant_order_id",
            "map_order_id"
          );
          let date_created = moment.utc(order["date_created"]);
          order["date_created"] = moment(date_created)
            .local()
            .format("DD.MM.YY HH:mm:ss");
          let date_updated = moment.utc(order["date_updated"]);
          order["date_updated"] = moment(date_updated)
            .local()
            .format("DD.MM.YY HH:mm:ss");

          for (var key in order) {
            if (
              order[key] != "" &&
              order[key] != null &&
              order[key] != undefined
            ) {
              var row = {
                field: key,
                data: order[key]
              };
              transactionInfo["info"].push(row);
            }
          }
        })
        .catch(err => {
          throw err;
        });
      return transactionInfo;
    },
    getSplitInfo(row) {
      if (row != null) {
        let split = _.pick(
          row,
          "date_created",
          "date_updated",
          "amount",
          "currency_code",
          "split_terminal_id",
          "merchant_id",
          "merchant_order_id",
          "map_order_id"
        );
        let date_created = moment.utc(split["date_created"]);
        split["date_created"] = moment(date_created)
          .local()
          .format("DD.MM.YY HH:mm:ss");
        let date_updated = moment.utc(split["date_updated"]);
        split["date_updated"] = moment(date_updated)
          .local()
          .format("DD.MM.YY HH:mm:ss");

        let sInfo = { info: [] };
        for (var key in split) {
          if (
            split[key] != "" &&
            split[key] != null &&
            split[key] != undefined
          ) {
            let dataRow = { field: key, data: split[key] };
            sInfo.info.push(dataRow);
          }
        }
        return sInfo;
      }
    },
    getSplit(id) {
      var params = {
        transaction_id: id,
        offset: 0,
        order_by: "id",
        order: "desc"
      };
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      var orderSplit = [];
      axios
        .post(apiUrl + "split", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total > 0) {
            data.list.forEach(item => {
              orderSplit.push(item);
            });
          }
        })
        .catch(err => {
          orderSplit = [];
          throw err;
        });
      return orderSplit;
    }
  },
  beforeMount() {
    if (
      localStorage.getItem("splits_filters") == null &&
      localStorage.getItem("splits_filters") == undefined
    )
      this.loadAsyncData();
  },
  created() {
    this.$store.dispatch("getTerminal").then(() => {
      this.$store.dispatch("getCustomParams");
      this.customP = this.customParams;
      this.flag_cp = true;
    });
    this.$store.dispatch("getProcessing");
    this.$store.dispatch("getRules");
    this.$store.dispatch("getMerchant");
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getRights",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "customParams",
      "processingList",
      "processingName",
      "processingIcon",
      "statusList",
      "cardClass",
      "cardName",
      "holderImg",
      "customParams",
      "decisionAF",
      "afruleName",
      "statusName",
      "statusStyle",
      "currencyCharacter",
      "countryNameRu"
    ])
  },
  components: {
    VisualSearch,
    OrderInfo,
    AntifraudRules,
    OrderSplit,
    VuePerfectScrollbar
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped></style>
